import React, { lazy, Suspense } from 'react'
import styles from "./gallery.module.scss"
import { Skeleton, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
const Card = lazy(() => import('../utils/card'));

const Gallery = (props) => {
  const radioValueFilter = (data, categoryArray) => {
    for (var i = 0; i < data.length; i++) {
      if (data[i].includes(',')) {
        let array = data[i].split(',');
        for (var j = 0; j < array.length; j++) {
          if (categoryArray.includes(array[j].trim())) {
            return data
          }
        }
      }
      if (categoryArray.includes(data[i])) {
        return data
      }
    }
  }
  const searchData = (data) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return data[2].toLowerCase().includes(props.inputValue.trim().toLowerCase())
      default:
        return data[1].toLowerCase().includes(props.inputValue.trim().toLowerCase())
    }
  }
  const filterData = (data, props) => {
    const filterByRadioValue = (filter) => {
      return filter && filter.length > 0 ? (data => radioValueFilter(data, filter)) : null;
    };
    const filters = [
      props.inputValue && searchData,
      filterByRadioValue(props.layoutsFilter),
      filterByRadioValue(props.placementsFilter),
      filterByRadioValue(props.featuresFilter),
      filterByRadioValue(props.industriesFilter),
      filterByRadioValue(props.devicesFilter),
      filterByRadioValue(props.performancesFilter),
      filterByRadioValue(props.deliverySystemsFilter),
    ].filter(Boolean);

    return data
      .filter(data => !data[11] || data[11].trim().toLowerCase() !== 'true')
      .map(data => {
        const layoutData = props.layouts?.find(layout => data[3] === layout[0]);
        return layoutData ? data.concat(layoutData.slice(3, 7)) : data;
      })
      .filter(data => filters.every(filter => filter(data)));
  };

  const LoadingCard = (key) => (
    <div key={key} className={`${styles.card} flexFont`}>
      <Skeleton animation="wave" variant="rectangular" width={320} height={170} />
      <Box sx={{ padding: '20px' }}>
        <Skeleton animation="wave" height={10} style={{ marginBottom: 8 }} />
        <Skeleton animation="wave" height={10} style={{ marginBottom: 8 }} width="80%" />
        <Skeleton animation="wave" height={10} width="40%" />
      </Box>
    </div>
  );

  return !props.data ?
    (
      <main className={`${styles.gallery} ${props.location.pathname === '/' ? '' : styles.none}`}>
        <div className={styles.search}>
          <div>
            <button className={styles.searchButton}>
              <SearchIcon />
              <input type="text" onChange={(e) => props.getInputValue(e.target.value)} />
            </button>
          </div>
        </div>
        <div className={styles.container}>
          {Array.from({ length: 12 }).map((_, index) => (
            <LoadingCard key={index} />
          ))}
        </div>
      </main>
    ) : (
      <main className={`${styles.gallery} ${props.location.pathname === '/' ? '' : styles.none}`}>
        <div className={styles.search}>
          <div>
            <button className={styles.searchButton}>
              <SearchIcon />
              <input onChange={(e) => props.getInputValue(e.target.value)} />
            </button>
          </div>
        </div>
        <div className={styles.container}>
          {filterData(props.data, props).map(data => (
            <Suspense key={data[0]} fallback={<LoadingCard />}>
              <Card instance={data} data={props} />
            </Suspense>
          ))}
        </div>
      </main>
    )
}
export default Gallery